import { AxiosResponse } from 'axios';
import { PaginateObj } from '../types/Paginate/PaginateObjt';
import apiInterceptor from '../utils/axios';
import { ItemRevisor } from '../types/Revisor/ItemRevisor';
import { SeguimientoDTO } from '../types/Seguimiento/SeguimientoDTO';
import { AprobacionData } from '../types/Revisor/AporbacionData';
import { GenericResponseListData } from '../types/Response/GenericResponse';

const SERV_BACK: string = process.env.REACT_APP_API_ESPOL_ADS || '';
const APIREVISOR = 'api/Catalog/revisor/';

export default class RevisorService {

    static async GetAnunciosParaRevisor(estado: string): Promise<PaginateObj<ItemRevisor>> {
        const response1: AxiosResponse<PaginateObj<ItemRevisor>> = await apiInterceptor.get(`${SERV_BACK}${APIREVISOR}page-anuncio/${estado}`,
            {
                headers: {
                    "Content-type": "application/json",
                },
            }
        );
        return response1.data;
    }

    static async GetAnunciosParaRevisorSearch(estado: string, name: string = ''): Promise<PaginateObj<ItemRevisor>> {
        const response1: AxiosResponse<PaginateObj<ItemRevisor>> = await apiInterceptor.get(`${SERV_BACK}${APIREVISOR}search-anuncio/${estado}/${name}`,
            {
                headers: {
                    "Content-type": "application/json",
                },
            }
        );
        return response1.data;
    }

    static async GetPage(link: string): Promise<PaginateObj<ItemRevisor>> {
        const response1: AxiosResponse<PaginateObj<ItemRevisor>> = await apiInterceptor.get(`${link}`);
        return response1.data;
    }

    static async GetPageByNumber(link: string, pageNum: number): Promise<PaginateObj<ItemRevisor>> {
        const baseUrl = link.substring(0, link.indexOf('?'));
        const params = new URLSearchParams({
            pageNumber: pageNum.toString(),
            pageSize: "8", // Tamaño fijo por página
        });
        const response1: AxiosResponse<PaginateObj<ItemRevisor>> = await apiInterceptor.get(`${baseUrl}?${params.toString()}`);
        return response1.data;
    }

    static async GetAnuncioHistorial(id: number): Promise<GenericResponseListData<SeguimientoDTO>> {
        try {
            const response: AxiosResponse<Array<SeguimientoDTO>> = await apiInterceptor.get(`${SERV_BACK}${APIREVISOR}historialRev/${id}`);
            if (response.status === 200) {
                return {
                    status: response.status,
                    message: 'Operación completada con éxito',
                    list_data: response.data
                };
            } else {
                console.error('Respuesta no exitosa:', response.status);
                return {
                    status: response.status,
                    message: `Error: Código de estado ${response.status}`,
                    list_data: []
                };
            }
        } catch (error) {
            console.error('Error al realizar la solicitud:', error);
            return {
                status: 500,
                message: 'Error al realizar la solicitud',
                list_data: []
            };
        }
        
    }

    static async GetAnunciosParaAprobar(id: number): Promise<AprobacionData> {
        const response1: AxiosResponse<AprobacionData> = await apiInterceptor.get(`${SERV_BACK}${APIREVISOR}${id}`,
            {
                headers: {
                    "Content-type": "application/json",
                },
            }
        );
        return response1.data;
    }

}